<template>
  <ProSpaceGeoLayout class="area" v-if="model">
    <template #top>
      <ProSpaceTopPanel :header="layoutName" back @back="backHandler">
        <template #right>
          <ProSpaceAction
            :disabled="v$.model.$invalid"
            icon="double-check"
            :text="$t('saveAll')"
            @click="saveAll"
          />
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout
        :is-templated="true"
        :template-center="true"
        :template-right="true"
      >
        <template #center>
          <ProSpaceTabs :tabs="overviewTabs" :loading="loading">
            <ProSpaceAction
              :disabled="v$.model.$invalid"
              icon="check"
              :text="$t('save')"
              @click="savePart(saveFieds.Overview)"
            />
            <template v-slot:tab-1>
              <ProSpaceVLayout :gap="20">
                <ProSpaceGeoLayout class="geo-row">
                  <template v-if="prefixTop || prefixBottom" v-slot:left>
                    <ProSpaceTextBlock
                      :top="prefixTop"
                      :bottom="prefixBottom"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceHLayout
                      justify-content="space-between"
                      align-items="flex-start"
                      :gap="10"
                    >
                      <ProSpaceInputText
                        v-model="model.value"
                        :label="$t('areaValue')"
                        :placeholder="$t('areaValue')"
                        :invalid="v$.model.value.$error"
                        :invalid-messages="v$.model.value.$errors"
                        @blur="v$.model.value.$touch"
                      />
                    </ProSpaceHLayout>
                  </template>
                  <template v-if="v$.model.value.$error" v-slot:right>
                    <ProSpaceVLayout justify-content="center">
                      <ProSpaceIcon icon="warning" colored />
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
              </ProSpaceVLayout>
            </template>
          </ProSpaceTabs>
        </template>
        <template #right>
          <ProSpaceRightPanel no-border>
            <template #center>
              <ProSpacePanelBlock :header="ProSpacePanelBlockHeader">
                <template v-slot>
                  <ProSpacePanelBlockList :list="ProSpacePanelBlockListComputed" />
                </template>
              </ProSpacePanelBlock>
            </template>
          </ProSpaceRightPanel>
        </template>
      </ProSpaceGeoLayout>
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceTopPanel,
  ProSpaceInputText,
  ProSpaceAction,
  ProSpaceRadioButtonSecondary,
  ProSpaceGeoLayout,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpaceTextBlock,
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceDropdown,
  ProSpaceFile,
  ProSpaceInputCalendar,
  ProSpaceInputNumber,
  ProSpaceSearchfield,
  ProSpaceMultiSelect,
  ProSpaceCustomFilterPanel,
  ProSpaceIcon,
} from "@prospace/prospace-components-library";
import { AreaService } from "../../services/AreaService.js";
import { mapGetters } from "vuex";
import { required, maxLength, helpers, minValue, maxValue } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {
  components: {
    ProSpaceTopPanel,
    ProSpaceGeoLayout,
    ProSpaceInputText,
    ProSpaceAction,
    ProSpaceRadioButtonSecondary,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpaceTextBlock,
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceDropdown,
    ProSpaceFile,
    ProSpaceInputCalendar,
    ProSpaceInputNumber,
    ProSpaceSearchfield,
    ProSpaceMultiSelect,
    ProSpaceCustomFilterPanel,
    ProSpaceIcon,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    this.tabs = [{ label: "Overview", value: "Overview" }];
    return {
      // Tabs
      modelTab: this.tabs[0], // Первое предустановленное значение

      // Common
      layoutName: "",
      model: null,
      loading: false,

      // Service
      areaService: new AreaService(),

      getMethod: "get",
      masterId: null,

      // SaveFieds
      saveFieds: {
        Overview: ["value"],
      },

      prefixTop: "",
      prefixBottom: "",
      gridSkip: null,
    };
  },
  validations() {
    return {
      model: {
        value: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
          maxLength: helpers.withMessage(
            this.$t("maxLengthErrorMessage"),
            maxLength(255)
          ),
        },
      },
    };
  },
  mounted() {
    if (this.$route.query.skip) {
      this.gridSkip = this.$route.query.skip;
    }
    this.getData();
  },
  methods: {
    gridLoaded() {},
    async getData() {
      this.masterId = this.$route.params.id;
      if (this.masterId === undefined) {
        // redirect to 404
        return;
      }
      const result = await this.areaService[this.getMethod](this.masterId);
      this.model = result.data;
      this.layoutName = `${this.model.value}`;
    },
    saveAll() {
      this.loading = true;
      this.areaService.set().then(() => {
        this.getData();
        this.loading = false;
      });
    },
    savePart(fields) {
      this.loading = true;
      this.areaService.setPart(fields).then(() => {
        this.getData();
        this.loading = false;
      });
    },
    submitFilter(nameRef = "grid") {
      if (!this.$refs[nameRef]) return;
      this.$refs[nameRef].getRecords(true);
    },
    backHandler() {
      this.$router.push({
        name: "areas",
        params: {
          gridSkip: this.gridSkip,
        },
      });
    },
  },
  computed: {
    ...mapGetters({
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    ProSpacePanelBlockListComputed() {
      return [
        [
          {
            title: this.$t("createdByTxt"),
            text: this.model.createdBy,
          },
        ],
        [
          {
            title: this.$t("createdAtTxt"),
            text: this.getFormatDateTime(new Date(this.model.createdAt)),
          },
          {
            title: this.$t("lastUpdatedTxt"),
            text: this.getFormatDateTime(new Date(this.model.lastUpdated)),
          },
        ],
      ];
    },
    overviewTabs() {
      return [{ name: this.$t("overview") }];
    },
    ProSpacePanelBlockHeader() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
  },
};
</script>
<style lang="scss"></style>
